import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BusService } from './bus.service';
import { EventsService } from './events.service';
import { IHandlers, RequestService } from './request.service';

@Injectable()
export class FileUploadService {
  constructor(
    private client: RequestService,
    private bus: BusService,
    private events: EventsService,
  ) {}

  upload(
    endpoint: string,
    fileToUpload: File,
    handlers?: IHandlers<any>,
  ): Observable<any> {
    if (!fileToUpload) {
      return of();
    }

    const formData: FormData = new FormData();

    formData.append('image', fileToUpload, fileToUpload.name);
    return this.client.upload<any, any>(formData, {
      uri: endpoint,
      body: {},
      handlers: handlers || {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }
}
